import React, { useEffect, useRef, useState } from 'react';
import { ChevronDownIcon, MenuIcon, PhoneIcon, MapPinIcon, XIcon } from 'lucide-react';
import { CATEGORIES, CONTACT, IMAGES, LINKS, SECONDARY_CATALOG_LINKS } from '../data/site';
const NAV = [{
  name: 'Workshops',
  href: LINKS.workshops
}, {
  name: 'Custom Fabrication',
  href: LINKS.fabrication
}, {
  name: 'Our Story',
  href: LINKS.story
}, {
  name: 'Contact',
  href: LINKS.contact
}];
const SHOP_MENU = [...CATEGORIES.map(c => ({
  name: c.name,
  href: c.href
})), {
  name: 'ECKOLD Machines',
  href: LINKS.eckold
}, ...SECONDARY_CATALOG_LINKS, {
  name: 'Shop All Tools',
  href: LINKS.shopAll
}];
export function Header() {
  const [shopOpen, setShopOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const shopWrapRef = useRef<HTMLDivElement>(null);
  const shopButtonRef = useRef<HTMLButtonElement>(null);
  const mobileButtonRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!shopOpen && !mobileOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        if (mobileOpen) mobileButtonRef.current?.focus();else shopButtonRef.current?.focus();
        setShopOpen(false);
        setMobileOpen(false);
      }
    };
    const onClick = (e: MouseEvent) => {
      if (shopWrapRef.current && !shopWrapRef.current.contains(e.target as Node)) setShopOpen(false);
    };
    document.addEventListener('keydown', onKey);
    document.addEventListener('mousedown', onClick);
    return () => {
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('mousedown', onClick);
    };
  }, [shopOpen, mobileOpen]);
  return <header className="relative z-40 bg-cream" data-id="element-135" data-mp="35j6el0fg4p0u">
      <div className="bg-charcoal text-steel-200" data-id="element-136" data-mp="30lehlrzy2cps">
        <div className="mx-auto flex max-w-[1240px] items-center justify-between gap-4 px-5 py-2 text-[12px] sm:px-8 sm:text-[13px]" data-id="element-137" data-mp="1wfqgqe5ogye">
          <p className="leading-snug" data-id="element-138" data-mp="3tav6wgs9pdhs">Metal Shaping Tools, Workshops &amp; Custom Fabrication</p>
          <div className="hidden items-center gap-5 sm:flex" data-id="element-139" data-mp="1rdbbsnygr0r6">
            <p className="flex items-center gap-2" data-id="element-140" data-mp="1rfxk4pt6hkag">
              <MapPinIcon aria-hidden="true" className="h-3.5 w-3.5 text-fred" data-id="element-141" data-mp="1wbcu36o2ew1l" />
              <span data-id="element-142" data-mp="1hojlslcyqqiw">Mt. Clemens, Michigan</span>
            </p>
            <a href={CONTACT.phoneHref} className="flex items-center gap-2 font-medium text-white transition-colors duration-150 ease-out hover:text-fred" data-id="element-143" data-mp="1hlxdgji906zm">
              <PhoneIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-144" data-mp="18pg0rbu8k11r" />
              <span data-id="element-145" data-mp="1cq8ae670s7yk">{CONTACT.phoneLabel}</span>
            </a>
          </div>
        </div>
      </div>

      <div className="border-b border-steel-200" data-id="element-146" data-mp="yqqktolwgqo5">
        <div className="mx-auto flex h-[84px] max-w-[1240px] items-center justify-between gap-3 px-5 max-[359px]:gap-2 max-[359px]:px-3 sm:h-[92px] sm:gap-6 sm:px-8" data-id="element-147" data-mp="13nh0iatslk91">
          <a href="/" className="flex shrink-0 items-center" aria-label="Fournier Enterprises home" data-id="element-148" data-mp="2t13zi0xwa3m6">
            <img src={IMAGES.headerLogo} width={394} height={252} alt="Fournier Enterprises" className="h-[80px] w-auto object-contain mix-blend-multiply sm:h-[88px]" data-id="element-149" data-mp="2xznlu2gehhf2" />
          </a>

          <nav aria-label="Primary" className="hidden items-center gap-1 lg:flex" data-id="element-150" data-mp="w60yjz3q49t1">
            <div ref={shopWrapRef} className="relative" data-id="element-151" data-mp="rcpycgtf2ra3">
              <button type="button" ref={shopButtonRef} aria-controls="shop-menu" aria-expanded={shopOpen} aria-haspopup="true" onClick={() => setShopOpen(v => !v)} className="flex min-h-[44px] items-center gap-1.5 px-3 font-display text-[19px] font-semibold uppercase tracking-[0.05em] text-charcoal transition-colors duration-150 ease-out hover:text-fred" data-id="element-152" data-mp="1555uqyrtbr21">
                Shop Tools
                <ChevronDownIcon aria-hidden="true" className={`h-4 w-4 transition-transform duration-150 ease-out ${shopOpen ? 'rotate-180' : ''}`} data-id="element-153" data-mp="3bw5bptxvh95b" />
              </button>
              {shopOpen && <div id="shop-menu" className="absolute left-0 top-full z-50 w-[300px] border border-steel-200 bg-white py-2 shadow-[0_18px_40px_-24px_rgba(25,27,29,0.5)]" data-id="element-154" data-mp="27zuvvsv4k8on">
                  <ul data-id="element-155" data-mp="1k85uln0bs9vk">
                    {SHOP_MENU.map(item => <li key={item.name} data-id="element-156" data-mp="1k62ycl8kxkie">
                        <a href={item.href} className="flex min-h-[44px] items-center px-4 py-2 text-[14px] text-ink transition-colors duration-150 ease-out hover:bg-cream hover:text-fred" data-id="element-157" data-mp="1p6qzhzqivhqc">
                          {item.name}
                        </a>
                      </li>)}
                  </ul>
                </div>}
            </div>

            {NAV.map(item => <a key={item.name} href={item.href} className="flex min-h-[44px] items-center px-3 font-display text-[19px] uppercase tracking-[0.05em] text-charcoal transition-colors duration-150 ease-out hover:text-fred" data-id="element-158" data-mp="y0aa649865l3">
                {item.name}
              </a>)}

            <a href={LINKS.shopAll} className="ml-3 flex min-h-[44px] items-center bg-fred px-5 font-display text-[18px] uppercase tracking-[0.07em] text-white transition-colors duration-150 ease-out hover:bg-fred-dark" data-id="element-159" data-mp="jzhaz67zambn">
              Shop All Tools
            </a>
          </nav>

          <div className="flex items-center gap-2 lg:hidden" data-id="element-160" data-mp="58qli4tuzzbp">
            <div className="flex shrink-0 flex-col items-end leading-tight sm:hidden" data-id="element-161" data-mp="1astku8pez4m">
              <span className="whitespace-nowrap text-[11px] text-steel-600 max-[359px]:text-[10px]" data-id="element-162" data-mp="3sercac41nnid">Mt. Clemens, MI</span>
              <a href={CONTACT.phoneHref} className="whitespace-nowrap text-[13px] font-semibold text-charcoal max-[359px]:text-[11px] transition-colors duration-150 ease-out hover:text-fred" data-id="element-163" data-mp="3nh7uj2850slo">
                {CONTACT.phoneLabel}
              </a>
            </div>

            <button type="button" onClick={() => setMobileOpen(v => !v)} ref={mobileButtonRef} aria-expanded={mobileOpen} aria-controls="mobile-menu" className="flex h-11 w-11 shrink-0 items-center justify-center border border-steel-200 text-charcoal" data-id="element-164" data-mp="33x0p7iv60gbi">
              <span className="sr-only" data-id="element-165" data-mp="3mujzsqx9u701">{mobileOpen ? 'Close menu' : 'Open menu'}</span>
              {mobileOpen ? <XIcon aria-hidden="true" className="h-5 w-5" data-id="element-166" data-mp="3rrk52zmar5q3" /> : <MenuIcon aria-hidden="true" className="h-5 w-5" data-id="element-167" data-mp="jc0gwf0hgdhw" />}
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && <div id="mobile-menu" className="border-b border-steel-200 bg-white lg:hidden" data-id="element-168" data-mp="28txdah1t3jse">
          <nav aria-label="Mobile" className="mx-auto max-w-[1240px] px-5 py-4 sm:px-8" data-id="element-169" data-mp="23v3y8k6vfkq4">
            <a href={LINKS.shopAll} className="mb-4 flex min-h-[48px] items-center justify-center bg-fred px-5 font-display text-[20px] uppercase tracking-[0.07em] text-white" data-id="element-170" data-mp="23t9ntzt87b0a">
              Shop All Tools
            </a>
            <p className="mb-2 font-display text-[13px] uppercase tracking-eyebrow text-steel-600" data-id="element-171" data-mp="1pw4bji2x5fwl">Shop Tools</p>
            <ul className="mb-4 border-t border-steel-100" data-id="element-172" data-mp="1kxt39bs9vdgh">
              {SHOP_MENU.slice(0, -1).map(item => <li key={item.name} className="border-b border-steel-100" data-id="element-173" data-mp="1ytwqgl4qaljg">
                  <a href={item.href} className="flex min-h-[48px] items-center text-[15px] text-ink" data-id="element-174" data-mp="1usuq20z2s3fw">
                    {item.name}
                  </a>
                </li>)}
            </ul>
            <ul className="border-t border-steel-100" data-id="element-175" data-mp="369ba67lkr893">
              {NAV.map(item => <li key={item.name} className="border-b border-steel-100" data-id="element-176" data-mp="13ogwl65m3ena">
                  <a href={item.href} className="flex min-h-[48px] items-center font-display text-[20px] uppercase tracking-[0.04em] text-charcoal" data-id="element-177" data-mp="18n1z5c8c6aew">
                    {item.name}
                  </a>
                </li>)}
            </ul>
            <a href={CONTACT.phoneHref} className="mt-4 flex min-h-[48px] items-center gap-2 font-medium text-charcoal" data-id="element-178" data-mp="1mcvpjyzhp2qq">
              <PhoneIcon aria-hidden="true" className="h-4 w-4 text-fred" data-id="element-179" data-mp="1wb1ruhp7kaw4" />
              {CONTACT.phoneLabel}
            </a>
          </nav>
        </div>}
    </header>;
}